import type { ObjectId } from "@bbj-types/utils";
import { Badge, Checkbox, FormControlLabel, FormGroup, Typography, type TypographyProps } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { MenuPopover } from "@surfaces/MenuPopover";
import { useCallback, useEffect, useState } from "react";

interface IFilterChallengesProps {
  values: ObjectId[];
  onChange: (values: ObjectId[]) => void;
  slotProps?: {
    label?: Partial<TypographyProps>;
  };
}

export const FilterChallenges = ({ values, onChange, slotProps }: IFilterChallengesProps) => {
  const { challenges } = useGlobalContext();
  const [localValues, setLocalValues] = useState<ObjectId[]>(values || []);
  const [isDirty, setDirty] = useState(false);

  const handleClose = useCallback(() => {
    if (isDirty) {
      onChange(localValues);
      setDirty(false);
    }
  }, [isDirty, localValues, onChange]);

  useEffect(() => {
    setLocalValues(values || []);
  }, [values]);

  return challenges.length > 0 ? (
    <Badge badgeContent={values.length > 0 ? values.length : undefined} color="yellow">
      <MenuPopover
        label={
          <Typography variant="body1" color="primary" {...slotProps?.label}>
            Thématiques
          </Typography>
        }
        onClose={handleClose}
      >
        <FormGroup>
          {challenges.map((challenge, index) => (
            <FormControlLabel
              sx={{ pr: 0.5, m: 0 }}
              key={challenge._id}
              label={challenge.name}
              checked={localValues.some((value) => value === challenge._id)}
              onChange={() => {
                setLocalValues((values) => {
                  const nValues = [...values];

                  const index = nValues.findIndex((value) => value === challenge._id);

                  if (index === -1) {
                    nValues.push(challenge._id);
                  } else {
                    nValues.splice(index, 1);
                  }

                  return nValues;
                });
                setDirty(true);
              }}
              control={<Checkbox size="small" sx={{ m: 0, mr: 0.5, p: 0.5 }} />}
            />
          ))}
        </FormGroup>
      </MenuPopover>
    </Badge>
  ) : null;
};
